<template>
  <div>
      <register :p_registerType="'register_by_authorized_person'"></register>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import {
  default as Register
} from '@/wam/views/register';
import { mapGetters } from 'vuex';
export default {
  name: 'register_by_authorized_person',
  computed: mapGetters({
    StoreLang: 'StoreLang',
  }),
  components: {
    Register,
  },
  props: {},
  data () {
    return {
      d_user: '',
    };
  },
  created: function () {
    this.d_user = JSON.parse(localStorage.getItem('user'));
    let user_perm_eligible = ClsUser.f_checkUserAuth(['admin','register']);
    if (this.d_user && this.d_user.username && user_perm_eligible) {
      // console.log(user_perm_eligible)
    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
  },
  beforeMount () {},
  mounted: function () {},
  methods: {
  },
  watch: {}
}

</script>

